module.exports = __webpack_public_path__ + "onboarding-machinePolicies.579e0c95c6114fe3688b512a0247c6ee.hashedasset.svg";